import { observable } from 'mobx';
import { DataSourceProvider, DataSource } from './DataSourceProvider';

export interface ResourceConfig {
  id: string | null;
  dataSource: string | DataSource;
  name: string;
  fields: string[];
  args?: { [key: string]: any };
  defaultValues?: { [key: string]: any };
}

export class Resource {
  id: string | null;
  name: string;
  dataSource: DataSource;
  fields: string[];
  args?: { [key: string]: any };

  @observable loading: boolean = false;
  @observable data: any | null = null;

  constructor(config: ResourceConfig) {
    this.id = config.id;
    if (typeof config.dataSource === 'string') {
      this.dataSource = DataSourceProvider.shared().getDataSource(
        config.dataSource
      );
    } else {
      this.dataSource = config.dataSource;
    }
    this.name = config.name;
    this.fields = config.fields;

    if (!this.id) {
      this.data = config.defaultValues;
    }
  }

  getIfHasID = async () => {
    // console.log('get???', this.id);
    if (this.id) {
      return this.get();
    }
  };

  reload = async () => {
    return this.get();
  };

  get = async () => {
    if (!this.id) {
      throw new Error('resource id is missing');
    }
    
    this.loading = true;
    let res = await this.dataSource.read(
      this.name,
      this.id,
      this.fields,
      this.args || {}
    );
    this.data = res;
    this.loading = false;
  };

  raw = async (args: any) => {
    if (!this.id) {
      throw new Error('resource id is missing');
    }
    this.loading = true;
    
    let res = await this.dataSource.raw(
      this.name,
      this.id,
      this.fields,
      args
    );
    this.data = res;
    this.loading = false;

    return res;
  };

  create = async (values: { [key: string]: any }) => {
    this.loading = true;
    let res = await this.dataSource.create(this.name, values, [
      'id',
      ...this.fields
    ]);
    // console.log('created???', res);
    this.data = res;
    this.id = res.id;
    this.loading = false;
  };
  update = async (values: { [key: string]: any }, args?: any) => {
    if (!this.id) {
      throw new Error('resource id is missing');
    }
    this.loading = true;
    let res = await this.dataSource.update(
      this.name,
      this.id,
      values,
      this.fields,
      args || {}
    );
    this.data = res;
    this.loading = false;
  };

  custom = async (name: string, values: { [key: string]: any }, args?: any) => {
    if (!this.id) {
      throw new Error('resource id is missing');
    }
    this.loading = true;

    let res = await this.dataSource.custom(
      name + this.name,
      this.id,
      values,
      this.fields,
      args || {}
    );
    this.data = res;
    this.loading = false;
  };

  delete = async () => {
    if (!this.id) {
      throw new Error('resource id is missing');
    }
    this.loading = true;
    let res = await this.dataSource.delete(this.name, this.id, this.fields);
    this.data = res;
    this.loading = false;
  };

  isPersisted = (): boolean => {
    return !!this.id;
  };

  save = async (values: { [key: string]: any }) => {
    if (!this.id) {
      return this.create(values);
    }
    return this.update(values);
  };
}



// WEBPACK FOOTER //
// ./src/store/Resource.ts